import { Button } from "@/components/Buttons/index";
import { useRouter } from "next/router";
import loginStyles from "@/styles/Login.module.scss";
import { idcLoginUrl, idcSignupUrl } from "@/lib/constants";
import IdcSignUpModal from "../IdcSignupModal";
import { useModal } from "@/hooks";
import { useCallback, useState } from "react";

// ログイン画面1
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LoginForm(props) {
  const router = useRouter();
  const {
    showModal,
    hideModal
  } = useModal();
  const onClickHandle = useCallback(url => {
    hideModal();
    props === null || props === void 0 || props.setIsSignupClicked(true);
    router.push(url);
  }, []);
  const showSignupModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(IdcSignUpModal, {
      onClickHandle: () => onClickHandle(idcSignupUrl)
    }), {
      closeButton: true,
      outerAreaClose: true,
      style: "dialogue"
    });
  }, [onClickHandle]);
  console.log("sentry", process.env);
  return /*#__PURE__*/_jsx("div", {
    className: loginStyles.contentWrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: loginStyles.loginSet,
      children: [/*#__PURE__*/_jsxs("div", {
        className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: loginStyles.flexTitle,
          children: /*#__PURE__*/_jsxs("p", {
            className: loginStyles.sectionTitle,
            children: ["\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u65B9", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: loginStyles.normalWeight,
              children: "(SPOOX ID\u3092\u304A\u6301\u3061\u3067\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u65B9/\u521D\u3081\u3066SPOOX\u5229\u7528\u3055\u308C\u308B\u65B9)"
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.sectionInner,
          children: /*#__PURE__*/_jsx("p", {
            className: loginStyles.button,
            children: /*#__PURE__*/_jsx(Button, {
              onClick: showSignupModal,
              fontBold: true,
              fillColor: true,
              large: true,
              fontFixed: true,
              children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BA\u65B0\u898F\u4F1A\u54E1\u767B\u9332"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.caption,
          children: "\u203BSPOOX ID\u3092\u304A\u6301\u3061\u306E\u304A\u5BA2\u69D8\u306F\u3001\u540C\u3058\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3068\u3057\u3066\u3054\u767B\u9332\u304F\u3060\u3055\u3044"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: loginStyles.flexTitle,
          children: /*#__PURE__*/_jsx("p", {
            className: loginStyles.sectionTitle,
            children: "\u65E2\u306B\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u304A\u6301\u3061\u306E\u65B9"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: loginStyles.sectionInner,
          children: /*#__PURE__*/_jsx("p", {
            className: loginStyles.button,
            children: /*#__PURE__*/_jsx(Button, {
              onClick: () => onClickHandle(idcLoginUrl),
              fontBold: true,
              fillColor: true,
              large: true,
              fontFixed: true,
              children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3067\u30ED\u30B0\u30A4\u30F3"
            })
          })
        })]
      })]
    })
  });
}